import { CallToAction, Grid, Header, Heading, Img, List, TextAndMedia } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import StartSimulationButton from 'components/start-simulation-button/StartSimulationButton'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import { useGetLanguage } from 'hooks/useGetLanguage'
import styles from './UspsOverview.module.scss'
import { I18nUSP } from 'types/i18n'

const UspsOverview = () => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'overview' })
  const language = useGetLanguage()

  return (
    <main>
      <Header title={t('header.title')} shape="s5">
        <p>{t('header.description')}</p>
        <StartSimulationButton />
      </Header>

      <TextAndMedia
        title={t('intro.title')}
        fullwidthMedia
        showMediaOnMobile
        media={{
          type: 'video',
          props: {
            publicId: 'website/usps/video',
            thumbnail: { publicId: 'website/usps/video-thumbnail', fill: true, alt: '' }
          }
        }}
      >
        <p>{t('intro.description')}</p>
      </TextAndMedia>

      <Grid title={t('usps.title')} classnames={{ list: styles.usps }}>
        <div key="local" className={styles['usp-card']}>
          <Img publicId="/website/usps/fun" alt="" width={400} height={400} />
          <Heading as="h2" variant="h4" serif>
            {t('usps.local.title')}
          </Heading>
          <p>{t('usps.local.description')}</p>
          <Link href={routes(language).uspsLocal}>{t('usps.local.action')}</Link>
        </div>

        <div key="fair-price" className={styles['usp-card']}>
          <Img publicId="/website/usps/how-it-works" alt="" width={400} height={400} />
          <Heading as="h2" variant="h4" serif>
            {t('usps.price.title')}
          </Heading>
          <p>{t('usps.price.description')}</p>
          <Link href={routes(language).uspsFairPrice}>{t('usps.price.action')}</Link>
        </div>

        <div key="customer-care" className={styles['usp-card']}>
          <Img publicId="/website/usps/care" alt="" width={400} height={400} />
          <Heading as="h2" variant="h4" serif>
            {t('usps.care.title')}
          </Heading>
          <p>{t('usps.care.description')}</p>
          <Link href={routes(language).uspsCustomerCare}>{t('usps.care.action')}</Link>
        </div>
      </Grid>

      <CallToAction title={t('cta.title')} color="dark" shape="s6" action={<StartSimulationButton />}>
        <p>{t('cta.description')}</p>
      </CallToAction>

      <TextAndMedia
        title={t('fun.title')}
        media={{
          type: 'image',
          imageBehaviour: '3-4',
          props: { publicId: '/website/usps/overview-fun', fill: true, alt: '', objectPosition: 'top right' }
        }}
      >
        <List as="ul" bullets="badgeCheck" className={styles.extras}>
          {(t('fun.bullets', { returnObjects: true }) as Omit<I18nUSP, 'key'>[]).map(({ title, description }, index) => (
            <li className={styles.bullet} key={`extra-${index}`}>
              <div className={styles['bullet-wrapper']}>
                <strong className="h4 serif">{title}</strong>
                <p>{description}</p>
              </div>
            </li>
          ))}
        </List>

        <Link representation="button" variant="secondary" href={routes(language).uspsFun} trailingIcon="chevronRight">
          {t('fun.action')}
        </Link>
      </TextAndMedia>

      <CallToAction title={t('cta2.title')} color="accent-soft" shape="s1" action={<StartSimulationButton text={t('cta2.action')} />}>
        <p>{t('cta2.description')}</p>
      </CallToAction>
    </main>
  )
}

export default UspsOverview
